import * as bi from 'react-bootstrap-icons';
import { Flex } from 'components';
import './style.scss';

interface IProps {
  children?: React.ReactNode | React.ReactNode[];
  error?: boolean;
  label?: string;
  icon?: React.ReactNode;
  value?: string;
  onChange?: (value: string) => void;
}

function Select(props: IProps) {
  if (props.label == null) {
    return <SelectInternal {...props} />;
  }

  return (
    <Flex
      direction='column'
      className={props.error ? 'l-err-NlAa' : undefined}
    >
      <div className={`l-nab1jA${props.error ? ' l-err-NlAa' : ''}`}>{props.label}</div>
      <SelectInternal {...props} />
    </Flex>
  );
}

function SelectInternal(props: IProps) {
  return (
    <div className={`select-cntr-BaQs${props.error ? ' err-Ng1g2s' : ''}`}>
      <div className='select-icon-NgaA down-NaVAp'>{<bi.ChevronDown />}</div>
      {props.icon != null && <div className='select-icon-NgaA ic-BflA1'>{props.icon}</div>}
      <select
        value={props.value}
        onChange={(e) => props.onChange?.(e.target.value)}
        className='select-NBCaa'
      >
        {props.children}
      </select>
    </div>
  );
}

export default Select;
